// extracted by mini-css-extract-plugin
export var desktopAndTablet = "videoInline-module--desktopAndTablet--CHRcp";
export var mobileOnly = "videoInline-module--mobileOnly--1vzLB";
export var sbShowMain = "videoInline-module--sb-show-main--LuWHx";
export var uploadedVideo = "videoInline-module--uploadedVideo--KXOqG";